import { fileMasiveConstants } from '../constants/index.js'

export const GetSignatureRequestsByUsuario = (state = {}, action) => {
    switch (action.type) {
        case fileMasiveConstants.FILE_SEARCH_MASIVE_REQUEST:
            return {
                loading: true,
                items: undefined,
                error: undefined
            }
        case fileMasiveConstants.FILE_SEARCH_MASIVE_SUCCESS:
            return {
                loading: false,
                items: action.dataSearch.Body,
                error: undefined
            }
        case fileMasiveConstants.FILE_SEARCH_MASIVE_FAILURE:
            return {
                loading: false,
                items: undefined,
                error: action.error
            }
        default:
            return state
    }
}

export const UploadBatchSign = (state = {}, action) => {
    switch (action.type) {
        case fileMasiveConstants.UPLOAD_SIGN_MASIVE_REQUEST:
            return {
                loading: true,
                items: undefined,
                error: undefined
            }
        case fileMasiveConstants.UPLOAD_SIGN_MASIVE_SUCCESS:
            return {
                loading: false,
                items: action.dataSearch.Body,
                error: undefined
            }
        case fileMasiveConstants.UPLOAD_SIGN_MASIVE_FAILURE:
            return {
                loading: false,
                items: undefined,
                error: action.error
            }
            case fileMasiveConstants.UPLOAD_SIGN_MASIVE_RESET:
                return {
                  loading: false,
                  items: undefined,
                  error: undefined
                }
        default:
            return state
    }
}

/* ------------------------------------------------------------------------ */

export const UsersSignersMasives = (state = {}, action) => {
    switch (action.type) {
        case fileMasiveConstants.GET_USERS_SIGNS_MASIVE:
            return {
                loading: false,
                items: action.payload,
                error: undefined
            }
        default:
            return state
    }
}
export const GetByUsuarioRolDetalleGrupo = (state = {}, action) => {
    switch (action.type) {
        case fileMasiveConstants.FILE_SEARCH_MASIVE_DEATILS_GROUP_REQUEST:
            return {
                loading: true,
                items: undefined,
                error: undefined
            }
        case fileMasiveConstants.FILE_SEARCH_MASIVE_DEATILS_GROUP_SUCCESS:
            return {
                loading: false,
                items: action.dataSearch.Body,
                error: undefined
            }
        case fileMasiveConstants.FILE_SEARCH_MASIVE_DEATILS_GROUP_FAILURE:
            return {
                loading: false,
                items: undefined,
                error: action.error
            }
        default:
            return state
    }
}

export const GetByUsuarioGruposStatus = (state = {}, action) => {
    switch (action.type) {
        case fileMasiveConstants.FILE_SEARCH_STATUS_MASIVE_REQUEST:
            return {
                loading: true,
                items: undefined,
                error: undefined
            }
        case fileMasiveConstants.FILE_SEARCH_STATUS_MASIVE_SUCCESS:
            return {
                loading: false,
                items: action.dataSearch.Body,
                error: undefined
            }
        case fileMasiveConstants.FILE_SEARCH_STATUS_MASIVE_FAILURE:
            return {
                loading: false,
                items: undefined,
                error: action.error
            }
        default:
            return state
    }
}


